import { CommonActions } from '@react-navigation/native';
import type { NavigationContainerRef, ParamListBase } from '@react-navigation/native';
import { DEFAULT_MAIN_TAB_ROUTE } from './LastMainTabContext';
import { shouldResetShellStack } from './shellNavigationPolicy';

const APP_SHELL_ROUTE = 'AppShell';
const MAIN_TABS_ROUTE = 'MainTabs';

let rootNavigationRef: NavigationContainerRef<ParamListBase> | null = null;

export function registerRootNavigationRef(ref: NavigationContainerRef<ParamListBase> | null): void {
  rootNavigationRef = ref;
  // Expose the navigation ref on `window` in __DEV__ so E2E tests can trigger
  // deep-link navigation with params (e.g. OrdersInbox with initialSegment).
  if (__DEV__ && typeof globalThis !== 'undefined') {
    (globalThis as Record<string, unknown>).__e2eNavRef = ref;
  }
}

export function getRootNavigationRef(): NavigationContainerRef<ParamListBase> | null {
  return rootNavigationRef;
}

/** Vuelve el stack del shell a MainTabs (p. ej. tras cambio de sucursal). */
export function resetShellStackOnBranchChange(): void {
  const nav = rootNavigationRef;
  if (!nav?.isReady?.()) return;

  const rootState = nav.getRootState();
  if (!shouldResetShellStack(rootState)) return;

  const registeredRoutes =
    rootState.routeNames ?? rootState.routes.map((route) => route.name);
  if (!registeredRoutes.includes(APP_SHELL_ROUTE)) return;

  nav.dispatch(
    CommonActions.reset({
      index: 0,
      routes: [
        {
          name: APP_SHELL_ROUTE,
          state: {
            index: 0,
            routes: [{ name: MAIN_TABS_ROUTE, params: { screen: DEFAULT_MAIN_TAB_ROUTE } }],
          },
        },
      ],
    })
  );
}
